export default __webpack_public_path__ + "static/media/team_sutton.751278b5.jpg";